"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillSliderWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const antd_1 = require("antd");
exports.SkillSliderWrapper = (0, styled_components_1.default)(antd_1.Slider) `
	width: 100%;
	.ant-slider-mark-text {
		font-size: 0.7rem;
	}
`;
